<template>
  <hi-card>
    <div class="p-4 flex flex-col gap-2">
      <div class="flex gap-4">
        <div>Active Enquiries:</div>
        <div>{{ activeNumber }}</div>
      </div>
      <div class="flex gap-4">
        <div>Closed Enquiries:</div>
        <div>{{ closedNumber }}</div>
      </div>
    </div>
  </hi-card>
</template>

<script>
import HiCard from "@/hive-vue3/components/HiCard";
import { computed } from "vue";
import {
  getClosedEnquires,
  getOpeningEnquiries,
} from "@/hive-vue3/modules/enquiries/data";
export default {
  name: "BasicEnquiryNumCard",
  components: { HiCard },
  setup() {
    const activeNumber = computed(() => {
      const res = getOpeningEnquiries();
      return res.length;
    });
    const closedNumber = computed(() => {
      const res = getClosedEnquires();
      return res.length;
    });

    return {
      activeNumber,
      closedNumber,
    };
  },
};
</script>

<style scoped></style>
